
<template>
	<div class="cancel-button">
		<slot />
	</div>
</template>
<script>
export default{
    name: 'cancel-button-image-fachada',
  components: {  }
}
</script>
<style lang="scss">
.cancel-button {
	position: absolute;
	right: 10px;
	top: 5%;
	transform: translateY(-50%);
}
</style>